import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson18: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson17"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Beginning Routine
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson19"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[6.25rem] text-justify text-gainsboro-100 font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>What is The Best Beginning Routine?</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              Similar to various aspects of life, the significance of experience
              cannot be undermined. In order to reach your desired destination,
              it is crucial to have a clear understanding of your current
              position. Your starting point is likely to differ from others,
              which means the path towards your ultimate goal may also vary.
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              Having this comprehension, take a moment to assess and determine
              where you currently stand on the spectrum between being a beginner
              and a seasoned veteran. Your level of experience, both in the gym
              and in terms of nutrition, will greatly influence the level of
              attention to detail required in your approach.
            </p>
          </div>
          <img
            className="relative w-[35.69rem] h-[31.56rem] object-cover"
            alt=""
            src="/32@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Beginner (0-2 Years Of Lifting Experience)</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The reality is that beginners have a unique advantage when it comes
            to simultaneous muscle building and fat loss. As a novice lifter,
            your body's physiology is optimized for muscle growth, making it
            relatively easier to achieve both goals. However, as you gain more
            experience in the gym, your muscles become more adapted and less
            responsive to training stimuli, making muscle building a slower and
            more challenging process.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Since muscle building requires significant energy, beginners have
            the ability to utilize stored body fat as fuel for this process.
            This means that beginners can achieve remarkable body recomposition
            without needing to meticulously focus on every aspect of their
            nutrition. For them, recomposition is comparatively easier and
            simpler.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            As long as you meet the following three criteria, you should be able
            to build muscle and lose fat as a beginner without the same level of
            optimization required for intermediate or advanced trainees:
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                Ensure your caloric intake is neither too high nor too low,
                meaning you are either in a slight caloric deficit or a slight
                caloric surplus. Specific examples and details will be provided
                later when we discuss setting up the diet.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                Maintain an adequate protein intake, which will be outlined in
                Chapter of macronutrients.
              </span>
            </li>
          </ul>
          <p className="m-0">
            Engage in weight training with a focus on progressive overload,
            gradually increasing weight, volume, or improving technique over
            time. The specifics of training for recomposition will be discussed
            later.
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                However, this does not mean that as a beginner, you can simply
                set the course aside. Following the recommendations outlined in
                the upcoming pages will yield even more impressive results for
                beginners who already have an inherent advantage. These
                strategies have the potential to elevate your progress from good
                to great.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>
              Intermediate (~2-5 Years Lifting) To Advanced (~5 or more years
              Lifting)
            </b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            As you progress towards the advanced end of the spectrum, the longer
            you engage in resistance training, the closer you come to reaching
            your genetic potential. If you are an experienced individual in the
            weight room, continuous progress becomes more challenging. This is
            where the often neglected and oversimplified aspects of nutritional
            science truly play a significant role in optimizing results.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            For intermediate to advanced lifters, simply meeting the three
            criteria mentioned earlier may not be sufficient to maximize
            outcomes. While they contribute to progress, your body's resistance
            to further advancements over time necessitates a greater level of
            fine-tuning to achieve the best possible results.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            While simplistic notions commonly accepted in the fitness industry
            may suffice for beginners, intermediate to advanced trainees must
            engage in deeper reflection. Concepts such as "calories-in versus
            calories-out," "a carb is a carb," and "eat according to your
            schedule" can provide rough approximations for beginners but can be
            misleading and limiting for those with greater experience. Our goal
            is to extract these topics from the sea of fitness discourse, place
            them on the table, shed light on them, and examine them more closely
            than most.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            In addition to unravelling often overlooked and misunderstood
            subjects, we will introduce new nutritional concepts. By combining
            scientific discoveries with our time-tested strategies, you will be
            equipped to optimize your nutritional approach, regardless of
            whether you are a beginner or a seasoned veteran!
          </p>
        </div>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson19"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson18;
